import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Create, FormTab, TabbedForm } from 'react-admin';
import { FormSpy } from 'react-final-form';
import omit from 'lodash/omit';

import CreateToolbar from '../../core/components/CreateToolbar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import CategorySummary from './CategorySummary';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const CategoryTitle = ({ record }) => {
  return (
    <FormTitleBar
      type="Document Category"
      name=""
      status=""
      creation={true}
      showAvatar={true}
      avatarContent={'CA'}
      recordLabel="Category"
    />
  );
};

class CategoryCreate extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  handleFormIsDirty(dirty) {
    // Block bnavigation when the form is dirty
    if (dirty !== this.state.whenBlockNavigation) {
      this.setState({ whenBlockNavigation: dirty });
    }
  }
  allowNavigationOnSave = () => {
    this.setState({ whenBlockNavigation: false });
  };

  render() {
    const { whenBlockNavigation } = this.state;
    const { classes } = this.props;

    return (
      <React.Fragment>
        <NavigationPrompt when={whenBlockNavigation} creation>
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Create
          {...omit(this.props, [
            'userProfile',
            'hasDeletePermission',
            'hasEditPermission',
            'hasCreatePermission'
          ])}
          record={{
            fundLevelFreeze: false,
            order: 0,
            triggerEmail: false,
            description: '',
            templateId: 0,
            categoryTypeId: 0,
            subType: 'REPORTING',
            status: 'ACTIVE',
            excludeFromDailySummary: false
          }}
          title={<CategoryTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <TabbedForm
            toolbar={
              <CreateToolbar
                allowNavigationOnSave={this.allowNavigationOnSave}
              />
            }
            variant="standard"
            margin="normal"
          >
            <FormTab label="Category Details">
              <CategorySummary creation={true} />
              <FormSpy
                subscription={{ dirty: true }}
                onChange={props => {
                  this.handleFormIsDirty(props.dirty);
                }}
              />
            </FormTab>
          </TabbedForm>
        </Create>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(CategoryCreate);
